import {ajax,getRequestUrl,formatData} from "../request";

export default {
  // 角色管理--角色列表
  roleList(data, method) {
    return ajax('post', getRequestUrl('/setting/role/list'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 角色管理--角色详情
  findRole(data, method) {
    return ajax('post', getRequestUrl('/api/Role/findRole'), data, {
      method,
    });
  },

  // 角色管理--创建角色
  createRole(data, method) {
    return ajax('post', getRequestUrl('/setting/role/create'), data, {
      method,
    });
  },

  // 角色管理--更新角色
  updateRole(data, method) {
    return ajax('post', getRequestUrl('/setting/role/update'), data, {
      method,
    });
  },

  // 角色管理--分配权限
  assignRolePower(data, method) {
    return ajax('post', getRequestUrl('/setting/role/assignRolePower'), data, {
      method,
    });
  },

  // 左边菜单
  leftMenu(data, method) {
    return ajax('post', getRequestUrl('/role/menu'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/role.js